import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import './ConfirmationModal.css';
import SpinnerOverlay from '../SpinnerOverlay/SpinnerOverlay';
import { Button } from '../EntityList';

function ConfirmationModal({ show, handleClose, handleConfirm, title = '', description = '', confirmCaption = 'Confirmar', cancelCaption = 'Cancelar', checkboxLabel = '', checkboxDefaultValue = false }) {
	const [loading, setLoading] = useState(false);
	const [checkboxValue, setCheckboxValue] = useState(checkboxDefaultValue);

	const confirm = async (e) => {
		if (e) {
			e.stopPropagation();
			e.preventDefault();
		}
		setLoading(true);
		await handleConfirm(checkboxValue);
		setLoading(false);
		handleClose();
	};

	const handleCloseModal = (e) => {
		if (e) {
			e.stopPropagation();
			e.preventDefault();
		}
		handleClose();
	};

	return (
		<Modal
			show={show}
			onHide={handleCloseModal}
			animation={false}
			centered
			dialogClassName='confirm-modal'
			contentClassName='entity-list-page el-modal tw:font-sans tw:text-[14px]/[1.45] tw:text-ink-0'
			onClick={(e) => {
				// Prevent event propagation to avoid triggering navigation
				e.stopPropagation();
			}}
		>
			<Modal.Header
				closeButton={!loading}
				onClick={(e) => e.stopPropagation()}
				className='tw:border-b tw:border-border tw:px-[22px] tw:py-[16px]'
			>
				<Modal.Title className='tw:text-[16px] tw:font-bold tw:tracking-[-0.01em] tw:text-ink-0'>{title}</Modal.Title>
			</Modal.Header>
			<Modal.Body
				onClick={(e) => e.stopPropagation()}
				className='tw:relative tw:px-[22px] tw:py-[18px] tw:text-[13.5px] tw:text-ink-1'
			>
				<p className='tw:mb-0'>{description}</p>
				{checkboxLabel && (
					<Form.Check
						type='checkbox'
						id='confirmation-checkbox'
						label={checkboxLabel}
						checked={checkboxValue}
						onChange={(e) => setCheckboxValue(e.target.checked)}
						disabled={loading}
						className='tw:mt-3'
					/>
				)}
				{loading && <SpinnerOverlay loading={loading} />}
			</Modal.Body>
			<Modal.Footer
				onClick={(e) => e.stopPropagation()}
				className='tw:border-t tw:border-border tw:bg-surface-2 tw:px-[22px] tw:py-[14px] tw:gap-2'
			>
				<Button disabled={loading} onClick={handleCloseModal}>
					{cancelCaption}
				</Button>
				<Button variant='primary' disabled={loading} onClick={confirm}>
					{confirmCaption}
				</Button>
			</Modal.Footer>
		</Modal>
	);
}

export default ConfirmationModal;
